import React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  useColorModeValue,
  SimpleGrid,
  Icon,
  Flex,
  Select,
  Divider,
  Stack,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import AddSpreadSheet from "./components/addSpreadSheet";
import DataInput from "./components/DataInput";
import Loader from "../../../components/loader/Loader";
import { useListContext } from "../../../contexts/listContext";

const Index = () => {
  const { list } = useListContext();
  const [successAlert, setSuccessAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const handleMappingSubmit = async (fileData, options = {}) => {
    console.log("Received Mapping Data:", fileData);

    try {
      setIsLoading(true);

      // Prevent redundant API calls if AddSpreadSheet.js handled the upload
      if (options.isBulkInsert || options.isExcelUpload) {
        setIsLoading(false);
        handleSuccessAlert(options.message || "Data saved successfully!");
        return;
      }

      // Regular add listing endpoint (for manual DataInput)
      const response = await fetch(
        `${backendUrl}/api/products/addListingManually`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: fileData }),
        }
      );

      if (response.ok) {
        setIsLoading(false);
        const responseData = await response.json();
        console.log("API Response:", responseData);
        handleSuccessAlert("Data saved successfully");
      } else {
        setIsLoading(false);
        const errorData = await response.json();
        console.error("Error:", errorData);
        handleFailureAlert("Failed to save data");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Network error:", error);
      handleFailureAlert("An error occurred while saving data");
    }
  };

  const handleSuccessAlert = (alertMessage) => {
    setSuccessAlert(alertMessage);
    setTimeout(() => {
      setSuccessAlert("");
    }, 5000);
  };

  const handleFailureAlert = (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {isLoading && <Loader />}
      <Card>
        <AddSpreadSheet keywords={list} onMappingSubmit={handleMappingSubmit} />
        <Divider colorScheme="blue" orientation="horizontal" />
        <DataInput keywords={list} onSave={handleMappingSubmit} />
      </Card>

      <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
        {successAlert !== "" && (
          <Alert status="success" variant="left-accent" w="40vw">
            <AlertIcon />
            {successAlert}
          </Alert>
        )}
        {failureAlert !== "" && (
          <Alert status="error" variant="left-accent" w="40vw">
            <AlertIcon />
            {failureAlert}
          </Alert>
        )}
      </Stack>
    </Box>
  );
};

export default Index;
